export type TSearchParamsPatch = Record<string, string | string[] | null | undefined>;

export const patchSearchParams = (prev: URLSearchParams, patch: TSearchParamsPatch) => {
  const params = new URLSearchParams(prev);

  for (const [key, value] of Object.entries(patch)) {
    if (value === undefined) {
      continue;
    }
    if (value === null || value === '') {
      params.delete(key);
      continue;
    }
    if (Array.isArray(value)) {
      params.delete(key);
      value.filter(Boolean).forEach((item) => params.append(key, item));
      continue;
    }
    params.set(key, value);
  }

  return params;
};
